import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { RadioButtonPanels } from '@eika/radio-button';

import { EiendomVariant, EiendomVariant as Variant, SoeknadstypeWeb } from '../../generated-types';
import { useTranslation } from '../../translations';

export type EiendomsVariantFormData = {
    eiendomVariant: EiendomVariant | undefined;
};

interface Props {
    soeknadstype: SoeknadstypeWeb;
}

const EiendomsVariant: FC<Props> = ({ soeknadstype }) => {
    const { eiendomVariant, validationMessage } = useTranslation();
    const {
        control,
        formState: { errors },
    } = useFormContext<EiendomsVariantFormData>();

    return (
        <Controller
            name="eiendomVariant"
            control={control}
            rules={{
                validate: { ikkeValgt: (value: Variant | undefined) => value !== undefined },
            }}
            render={({ field: { onChange, value } }) => (
                <RadioButtonPanels
                    label={
                        soeknadstype === SoeknadstypeWeb.FINANSIERINGSBEVIS
                            ? eiendomVariant.labelTypeBoligSerEtter
                            : eiendomVariant.labelTypeBolig
                    }
                    selectedOption={value}
                    onChange={(value) => onChange(value as Variant)}
                    options={
                        soeknadstype === SoeknadstypeWeb.FINANSIERINGSBEVIS
                            ? [
                                  { label: eiendomVariant.selectValueLeilighet, value: Variant.LEILIGHET },
                                  {
                                      label: `${eiendomVariant.selectValueEnebolig}/${eiendomVariant.selectValueRekkehus}/${eiendomVariant.selectValueTomannsbolig}`,
                                      value: Variant.ENEBOLIG,
                                  },
                              ]
                            : [
                                  { label: eiendomVariant.selectValueSelveier, value: Variant.SELVEIER },
                                  { label: eiendomVariant.selectValueAndelIBorettslag, value: Variant.BORETTSANDEL },
                                  { label: eiendomVariant.selectValueAksjeleilighet, value: Variant.AKSJELEILIGHET },
                              ]
                    }
                    errorMessage={
                        errors.eiendomVariant?.type === 'ikkeValgt' ? `${validationMessage.requiredChoose}` : ''
                    }
                />
            )}
        />
    );
};

export default EiendomsVariant;
